'use client';

import type { PropsWithChildren, JSX } from 'react';
import React, { createContext, useContext } from 'react';

export const CurrentLanguageContext = createContext<string>('');

const CurrentLanguageProvider = (props: PropsWithChildren<{ lng: string }>): JSX.Element => {
  const { children, lng } = props;

  return <CurrentLanguageContext.Provider value={lng}>{children}</CurrentLanguageContext.Provider>;
};

export const useCurrentLanguage = (): string => {
  return useContext(CurrentLanguageContext);
};

export default CurrentLanguageProvider;
